import { render, staticRenderFns } from "./newsDetailView.vue?vue&type=template&id=fa6dc93a&scoped=true"
import script from "./newsDetailView.vue?vue&type=script&lang=js"
export * from "./newsDetailView.vue?vue&type=script&lang=js"
import style0 from "./newsDetailView.vue?vue&type=style&index=0&id=fa6dc93a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa6dc93a",
  null
  
)

export default component.exports